<template lang="pug">
span
  search(
    data-test="cm-search"
    :value="filters.search"
    @change="setSearchFilter"
    placeholder='Search by CBR account, client name, data etc…'
  ).cm-body__search
  portal(to="cm-reserved")
    v-icon(small @click="toggleReserveFilter").copy-arrow mdi-menu-down
    v-dialog(v-model="reservedFilterShowing" :max-width="600")
      v-card
        v-card-title Exam date filters
        v-card-text
          filter-autocomplete(
            v-model="filters.examLocation"
            :getItems="getExamLocation"
            label="Exam Location"
            testName="exam-location"
            clearable
          )
          datepicker(
            v-model="filters.examDateAfter"
            label="Exam date from"
          )
          datepicker(
            v-model="filters.examDateBefore"
            label="Exam date to"
          )
        v-card-actions
          v-spacer
          v-btn(color="error" text @click="toggleReserveFilter") Close
          v-btn(color="success" text @click="submitExamFilter") Apply  
</template>

<script>
import {mapActions} from "vuex";

export default {
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    reservedFilterShowing: false
  }),
  methods: {
    toggleReserveFilter() {
      this.reservedFilterShowing = !this.reservedFilterShowing
    },
    
    setSearchFilter(value) {
      this.filters.search = value;
      this.$emit('filterChanged');
    },

    submitExamFilter() {
      this.toggleReserveFilter();
      this.$emit('filterChanged')
    },

    ...mapActions({
      getExamLocation: 'crmExamLocation/list',
    }),
  },
  components: {
    datepicker: () => import('@/app/admin/modules/candidates/components/filters/CandidateDatepickerFilters.vue'),
    filterAutocomplete: () => import('@/components/global/FilterAutocomplete.vue'),
    search: () => import('@/components/global/Search.vue'),
  },
}
</script>

<style lang="scss" scoped>
.cm-body {
  &__search{
    position: sticky;
    left: 0;

    &.v-input {
      padding-left: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 64px;
      border-bottom: 1px solid $border-color;
    }
  }
}
</style>
